import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import ISystemStatusMessage from '../model/ISystemStatusMessage'
import { StateEnum } from '../model/StateEnum'

export type SystemStatusState = {
  // Active messages for the top-of-screen banner (server-filtered, re-derived
  // client-side on each tick so scheduled boundaries take effect without reload).
  bannerMessages: ISystemStatusMessage[]
  // Full list for the BackOffice management table.
  adminMessages: ISystemStatusMessage[]
  adminLoadingState: StateEnum
  saving: boolean
}

const initState: SystemStatusState = {
  bannerMessages: [],
  adminMessages: [],
  adminLoadingState: StateEnum.INIT,
  saving: false
}

const systemStatusSlice = createSlice({
  name: 'systemStatusSlice',
  initialState: initState,
  reducers: {
    setBannerStatusMessages: (
      state,
      action: PayloadAction<{ messages: ISystemStatusMessage[] }>
    ): SystemStatusState => ({
      ...state,
      bannerMessages: action.payload.messages
    }),
    setStatusMessages: (
      state,
      action: PayloadAction<{ messages: ISystemStatusMessage[] }>
    ): SystemStatusState => ({
      ...state,
      adminMessages: action.payload.messages,
      adminLoadingState: StateEnum.LOADED
    }),
    setStatusMessagesLoadingState: (
      state,
      action: PayloadAction<{ loading: boolean }>
    ): SystemStatusState => ({
      ...state,
      adminLoadingState: action.payload.loading
        ? StateEnum.LOADING
        : StateEnum.LOADED
    }),
    setStatusMessageSaving: (
      state,
      action: PayloadAction<{ saving: boolean }>
    ): SystemStatusState => ({
      ...state,
      saving: action.payload.saving
    })
  }
})

export const {
  setBannerStatusMessages,
  setStatusMessages,
  setStatusMessagesLoadingState,
  setStatusMessageSaving
} = systemStatusSlice.actions

export default systemStatusSlice.reducer
